// CustomerInquiries.tsx
import { observer } from "mobx-react-lite";
import MainLayout from "../MainLayout";
import { useNavigate } from "react-router-dom";
import { VerticalLayout } from "../../common/common-layout";
import { TitleLargeMedium } from "../../common/common-text";
import { useEffect, useState } from "react";
import CustomerInquiry from "../../model/homepage/CustomerInquiry";
import { formatDateToYMD } from "../../common/utils/DateUtils";
import BTBox from "../../common/components/BTBox";
import BTList from "../../common/components/board/BTList";
import { GridRowParams } from "@mui/x-data-grid";
import { fetchCustomerInquiryList } from "../../service/HomepageService";

const CustomerInquiries = () => {
    return (
        <MainLayout>
            <CustomerInquiriesBody />
        </MainLayout>
    );
};

export default CustomerInquiries;

const CustomerInquiriesBody = observer(() => {
    const navigate = useNavigate();
    const [inquiries, setInquiries] = useState<CustomerInquiry[]>([]);
    const [selectedRows, setSelectedRows] = useState<number[]>([]);

    useEffect(() => {
        async function loadData() {
            const inquiries = await fetchCustomerInquiryList();

            setInquiries(inquiries);
        }

        loadData();
    }, []);

    const columns = [
        { field: 'id', headerName: '번호', width: 80, headerAlign: 'center', align: 'center' },
        { field: 'title', headerName: '제목', flex: 1, headerAlign: 'center', align: 'left' },
        { field: 'requestorName', headerName: '작성자', width: 120, headerAlign: 'center', align: 'center' },
        { field: 'email', headerName: '이메일', width: 240, headerAlign: 'center', align: 'center' },
        { field: 'createdAt', headerName: '접수일', width: 110, headerAlign: 'center', align: 'center' },
        { field: 'replyCompletedYn', headerName: '답변 여부', width: 120, headerAlign: 'center', align: 'center' }
    ];

    const rows = inquiries.map((inquiry, index) => ({
        id: inquiries.length - index,
        title: inquiry.title,
        requestorName: inquiry.requestorName,
        email: inquiry.email,
        createdAt: formatDateToYMD(inquiry.createdAt),
        replyCompletedYn: inquiry.replyCompletedYn ? '✅' : '❌',
        originalInquiry: inquiry
    }));

    const handleRowClick = (params: GridRowParams): void => {
        const matchedInquiry = params.row.originalInquiry;
        if (matchedInquiry) {
            navigate('/homepage/inquiries/detail', { state: matchedInquiry });
        }
    };

    return (
        <VerticalLayout height={'auto'} paddingLeft={36} paddingRight={36}>
            <TitleLargeMedium>문의하기 관리</TitleLargeMedium>
            <BTBox height='24px' />
            <BTList
                rows={rows}
                columns={columns}
                handleRowClick={handleRowClick}
                selectedRows={selectedRows}
                setSelectedRows={setSelectedRows}
                pageStateKey="homepage.inquiries.list"
            />
        </VerticalLayout>
    );
});